import { ApiEventResponse, Album, MediaItem } from '../types';

const API_BASE_URL = 'https://xnm8-lnj6-1v0k.p7.xano.io/api:exUHupL0';

export class ApiService {
  static async getEventDetails(eventCode: string): Promise<ApiEventResponse> {
    const url = `${API_BASE_URL}/get_event_details_by_code?event_code=${eventCode}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ApiEventResponse = await response.json();
      console.log('API Response - getEventDetails:', {
        url,
        eventCode,
        response: data
      });
      return data;
    } catch (error) {
      console.error('Error fetching event details:', error);
      throw new Error(`Failed to fetch event details: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  // Refresh event data to check for new media
  static async refreshEventDetails(eventCode: string): Promise<ApiEventResponse | null> {
    try {
      console.log('Refreshing event data for new media...');
      const data = await this.getEventDetails(eventCode);
      console.log('Event data refreshed successfully');
      return data;
    } catch (error) {
      console.warn('Failed to refresh event data:', error);
      return null; // Return null on error to avoid breaking the app
    }
  }

  static transformApiDataToAlbum(apiData: ApiEventResponse): Album {
    const media: MediaItem[] = apiData.media_of_events.map((item) => {
      const uploadedBy = item._user_profile 
        ? `${item._user_profile.first_name} ${item._user_profile.last_name}`.trim()
        : 'Unknown User';

      // Get metadata from image or video
      const metadata = item.media_type === 'image' && item.image 
        ? item.image.meta 
        : item.media_type === 'video' && item.video 
          ? item.video.meta 
          : undefined;

      return {
        id: item.id.toString(),
        type: item.media_type,
        url: item.media_type === 'image' && item.image 
          ? item.image.url 
          : item.media_type === 'video' && item.video 
            ? item.video.url 
            : '',
        uploadedBy: uploadedBy === ' ' ? 'Anonymous' : uploadedBy,
        duration: item.media_type === 'video' ? apiData._privilege_details.video_length : undefined,
        metadata: metadata,
      };
    });

    return {
      id: apiData.id.toString(),
      title: `Event ${apiData.event_code}`,
      eventName: apiData.event_name,
      media,
      shareUrl: `${window.location.origin}/${apiData.event_code}`,
      qrCodeUrl: apiData.qr_code.url,
    };
  }
}

// Utility function to extract event code from URL
export const getEventCodeFromUrl = (): string | null => {
  const path = window.location.pathname;
  const segments = path.split('/').filter(segment => segment.length > 0);
  
  // Event code should be the first segment after the domain
  return segments.length > 0 ? segments[0] : null;
};

// Utility function to build share URL
export const buildShareUrl = (eventCode: string): string => {
  return `${window.location.origin}/${eventCode}`;
};
